export const countryList = {
  'Austria': 0,
  'Belgium': 1,
  'Czech Republic': 2,
  'Germany': 3,
  'Denmark': 4,
  'Spain': 5,
  'Finland': 6,
  'France': 7,
  'United Kingdom': 8,
  'Italy': 9,
  'Netherlands': 10,
  'Poland': 11,
  'Portugal': 12,
  'Export': 13,
  'Brazil': 14,
  'North America': 15,
  'Australia': 16,
  'New Zealand': 17,
  'Asia': 18,
  'Canada': 19,
  'Hong Kong': 20,
  'Middle East': 21,
  'China': 22,
  'South East Asia': 23
};

export const languageList = {
  'English': 0,
  'German': 1,
  'Dutch': 2,
  'French': 3,
  'Czech': 4,
  'Spanish': 5,
  'Italian': 6,
  'Polish': 7,
  'Russian': 8,
  'Finnish': 9,
  'Danish': 10,
  'Portuguese': 11,
  'Portuguese, Brazil': 12,
  'English International': 13,
  'Turkish': 14,
  'English US': 15,
  'French, Canadian': 16,
};

export const standardList = {
  'EU': 0,
  'ICC.Post': 1.1,
  'ICC.Cast': 1.2,
  'ANZ': 2,
  'CSA': 3,
  'AS5216': 4,
  'AS3600': 5,
  'Masonry': 6,
  'AnnexC': 7
};

export const profileList = {
  'All': 3,
  'EU only': 0,
  'AISC only (North America)': 1,
  'Australian only': 2,
};

export const brandList = {
  Spit: 'Spit',
  Ramset: 'Ramset',
  Redhead: 'Redhead',
  Sea: 'Sea'
};



// WEBPACK FOOTER //
// ./src/app.values.js